import React, { Component } from 'react'

import { connect } from 'react-redux'
import * as api from '../../api/api'
import * as actions from '../../actions'
import { ListDivider } from 'rmwc/List';
import { Button, ButtonIcon } from 'rmwc/Button';
import { Link } from 'react-router-dom'
import {
  Dialog,
  DefaultDialogTemplate,
  DialogSurface,
  DialogHeader,
  DialogHeaderTitle,
  DialogBody,
  DialogFooter,
  DialogFooterButton,
  DialogBackdrop
} from 'rmwc/Dialog';

import {TextField} from 'rmwc/TextField';
import { FormField } from 'rmwc/FormField';

import SerializeForm from 'form-serialize'

import {
  Card,
  CardPrimaryAction,
  CardMedia,
  CardAction,
  CardActions,
  CardActionButtons,
  CardActionIcons,
} from 'rmwc/Card';

import { Snackbar } from 'rmwc/Snackbar';
import { Typography } from 'rmwc/Typography';
import { Grid, GridCell } from 'rmwc/Grid';
import { Select } from 'rmwc/Select'
import ReactExport from "react-data-export";

import SearchComponent from '../SearchComponent';
import StatusMessage from '../../util/StatusMessage'


class UserDetailsAdmin extends Component {
  constructor(props) {
    super(props)
    this.state = {
      status: '',
      message: '',
      open: false,
      snackbarIsOpen: false,
      exportMaxNumRecords: 10000,
      errorMsg: '',
      searchErrorMsg: '',
      prefErrorMsg: '',
      downloadDisable: true,
      searchStatus: false,
      userPreferenceExport:false,
      data: {
        page: 1,
        registeredUsers: [],
        total: 0,
        totalPages: '',
        exportData:[],
        start: 1,
        end: 10000,
        userPreferences: [],
        selectPreference: '',
        userId:'',
        userPrefExportData: []
      },
      searchData: {
        searchTerm: '',
        criteria: ''
      }
    }
    
    
  }


  componentDidMount() {
    
    let data = Object.assign({}, this.state.data)
    let searchData = Object.assign({}, this.state.searchData)
    return api.fetchAdminUserDetails(this.props.user.accessToken, this.state.data.page, searchData.criteria, searchData.searchTerm).then((result) => {
          const { status, errors} = result
          if (status === 'error') {
            this.setState({ errorMsg: 'Error in Fetching Detail' })  
          }
          if (status === 'success') {
            data.registeredUsers = result.data.users
            data.totalPages = result.pages
          }
        return api.getResponse(this.props.user.accessToken, '/admin/list/of/user/preference')
        }).then((result) => {
          if (result.status === 'success'){
            data.userPreferences = result.data
          }
           this.setState({data:data})
        })
        .catch((err) => {
          this.setState({ errorMsg: 'Error in Fetching Details' })
        })
    
  }


  handleSearch = (e) => {
    let data = Object.assign({}, this.state.data)
    let searchData = Object.assign({}, this.state.searchData)
    api.fetchAdminUserDetails(this.props.user.accessToken, data.page, searchData.criteria, searchData.searchTerm).then((result) => {
          const { status, errors} = result
          if (status === 'error') {
            this.setState({ errorMsg: 'Error in Fetching Detail' })  
          }
          if (status === 'success') {
            data.registeredUsers = result.data.users
            data.totalPages = result.pages
            this.setState({data:data, errorMsg: ''})
          }
        })
      .catch((err) => {
        this.setState({ errorMsg: 'Error in Fetching Details' })
    })
  }

 
  onOpenModal = () => {
    this.setState({ open: true });
  };

  onCloseModal = () => {
    this.setState({ open: false });
  };

  onInputChange = evt => {
    const data = Object.assign({}, this.state.data);
    data[evt.target.name] = evt.target.value;
    this.setState({data});
  };

  onUserIDChangeForExport = evt => {
    const data = Object.assign({}, this.state.data);
    data[evt.target.name] = evt.target.value;
    data.end = parseInt(data.start)+parseInt(this.state.exportMaxNumRecords)-1
    this.setState({data, downloadDisable:true});
  };

  handleExportUserData = e => {
    e.preventDefault()
    let data = Object.assign({}, this.state.data)
    if(!this.state.downloadDisable){
      this.setState({downloadDisable: true})
    }
    if(data.start > 0){
      api.exportUserRegData(this.props.user.accessToken, data.start).then((result) => {
        const { status, errors} = result
          if (status === 'success') {
            data.exportData = result.data
            this.setState({data:data, errorMsg:'', downloadDisable:false})
          }
        })
        .catch((err) => {
          this.setState({ errorMsg: 'Error in Fetching Details', downloadDisable:true })
        })
    }
    else{
      this.setState({errorMsg: 'Please provide valid User id (Start) for export'})
    }
    
    }

    handleUserSearch = (searchTerm, criteria, pageNo) => {
      let searchData = Object.assign({}, this.state.searchData)
      let data = Object.assign({}, this.state.data)
      let searchStatus = this.searchStatus
      searchData.searchTerm = searchTerm
      searchData.criteria = criteria
      searchStatus = true
      data.page = pageNo
      api.fetchAdminUserDetails(this.props.user.accessToken, pageNo, criteria, searchTerm).then((result) => {
        const { status, errors} = result
        if(status == 'error'){
          this.setState({searchErrorMsg: result.message, searchData: searchData, searchStatus: searchStatus})
        }
        else if (status == 'success'){
          data.registeredUsers = result.data.users
          data.totalPages = result.pages
          this.setState({data:data, searchErrorMsg: '', searchData: searchData, searchStatus: searchStatus})
        }
      })
      .catch((err) => {
        this.setState({ errorMsg: 'Error in Fetching Details' })
      })
    }

    handleClear = (e) => {
      e.preventDefault()
      let data = Object.assign({}, this.state.data)
      let searchData = Object.assign({},this.state.searchData)
      data.page = 1
      searchData.searchTerm = ''
      searchData.criteria = ''
      data.totalPages = ''
      this.setState({data: data, searchStatus: false, searchData: searchData})
    }

    handleUserPreferenceChange = (e) => {
      e.preventDefault()
      let data = Object.assign({}, this.state.data)
      let prefErrorMsg = this.prefErrorMsg
      data.selectPreference = e.target.value
      data.userId = ''
      prefErrorMsg = ''
      this.setState({data: data, prefErrorMsg: prefErrorMsg})
    }

    handlePreference = (e, type) => {
      e.preventDefault()
      let prefValue
      let prefErrorMsg = this.prefErrorMsg

      if((!this.state.data.userId) || (!this.state.data.selectPreference)){
        this.setState({prefErrorMsg: "Invalid Inputs"})
      }  
      else{
        prefValue = (type === 'disable') ? 0 : 1
      }
        
      let url = 'admin/update/user/preference'
      let apiInput={
        selected_preference: this.state.data.selectPreference,
        value: prefValue,
        user_id: this.state.data.userId
      }
      api.putValuesApi(this.props.user.accessToken, url, apiInput).then((result) => {
        this.setState({prefErrorMsg: result.message})
      })
      .catch((err) => {
        this.setState({ prefErrorMsg: 'Exception.Error in Fetching Details' })
      })
    }

    handleExportUserPreferenceData = (e) => {
      e.preventDefault()
      let data = Object.assign({}, this.state.data)
      if(!this.state.downloadDisable){
        this.setState({downloadDisable: true})
      }
      if(data.start > 0){
        let url = `admin/fetch/user/preference/export/${data.start}`
        api.getResponse(this.props.user.accessToken, url).then((result) => {
          const { status, errors} = result
            if (status === 'success') {
              data.userPrefExportData = result.data
              this.setState({data:data, errorMsg:'', downloadDisable:false, userPreferenceExport:true})
            }
          })
          .catch((err) => {
            this.setState({ errorMsg: 'Error in Fetching Details', downloadDisable:true })
          })
      }
      else{
        this.setState({errorMsg: 'Please provide valid User id (Start) for export'})
      }
    
    }

    render() {
    const { open } = this.state;
    const {registeredUser} = this.state;
     let userListCompnent
     let handleNotify = this.handleNotify
     let openModal = this.openModal
     let handleUserSearch = this.handleUserSearch
     let handleClear = this.handleClear
     let handleSearch = this.handleSearch
     let userPreferenceComponent = this.userPreferenceComponent
     if(this.state.data.registeredUsers.length >0){
      userListCompnent = 
        ( <tbody>
            {this.state.data.registeredUsers.map(regUser => (
              <tr>
                <td>{regUser.user_id}</td>
                <td>{regUser.user_name}</td>
                <td>{regUser.email}</td>
                <td>{regUser.phone}</td>
                <td>{regUser.confirm_otp}</td>
                <td>{regUser.active}</td>
                <td>{regUser.forgot_code}</td>
                <td>{regUser.creation_source}</td>
                <td>{regUser.email_preference}</td>
                <td>{regUser.first_name}</td>
                <td>{regUser.last_name}</td>
                <td>{regUser.gender_id}</td>
                <td>{regUser.dob}</td>
                <td>{regUser.created_at}</td>  
                <td>{regUser.street}</td>
                <td>{regUser.locality}</td>
                <td>{regUser.city}</td>
                <td>{regUser.country_id}</td>
                <td>{regUser.state_id}</td>   
              </tr>
            ))}
          </tbody>  
        )

     }


     let Snackbarcomponent =(
          <Snackbar
            show={this.state.snackbarIsOpen}
            onHide={evt => this.setState({snackbarIsOpen: false})}
            message="Notification email sent to user with the access link"
      />
      )

     let paginationComponent = (

                <div>
                  <TextField  className='text_input' label="Page Number" autoComplete="off" name="page" onChange={this.onInputChange} value={this.state.data.page}/>
                  <Button className="add-opportunity" onClick={this.handleSearch}>
                  Fetch
              </Button>
              <br/><br/>
                </div>
              
           
        )

      const ExcelFile = ReactExport.ExcelFile;
      const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
      const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

      let exportFieldsComponent =(
        <div>
        <TextField  className='text_input' type="number" label="User Id From" autoComplete="off" name="start" onChange={this.onUserIDChangeForExport} value={this.state.data.start}/>
                &nbsp;
            <TextField  className='text_input' type="number" disable label="To" autoComplete="off" name="start" value={this.state.data.end}/>
            <Button onClick={this.handleExportUserData}>Export</Button>
            <Button onClick={this.handleExportUserPreferenceData}>Pref Export</Button>
        </div>
        )

      let exportComponent
      if(this.state.userPreferenceExport){
        exportComponent =(
          <div className="">
              {exportFieldsComponent}
              <ExcelFile element={<Button disabled={this.state.downloadDisable}>Download</Button>}>
                <ExcelSheet data={this.state.data.userPrefExportData} name="userpreferenceexport">
                    <ExcelColumn label="user_id" value="user_id"/>
                    <ExcelColumn label="user_name" value="user_name"/>
                    <ExcelColumn label="email_preference" value="email_preference"/>
                </ExcelSheet>
              </ExcelFile>
          </div>
        )
      }
      else {
        exportComponent = (
          <div className="">
            {exportFieldsComponent}
            <ExcelFile element={<Button disabled={this.state.downloadDisable}>Download</Button>}>
              <ExcelSheet data={this.state.data.exportData} name="userexport">
                  <ExcelColumn label="user_id" value="user_id"/>
                  <ExcelColumn label="user_name" value="user_name"/>
                  <ExcelColumn label="first_name" value="first_name"/>
                  <ExcelColumn label="last_name" value="last_name"/>
                  <ExcelColumn label="email" value="email"/>
                  <ExcelColumn label="phone" value="phone"/>
                  <ExcelColumn label="GenderId" value="gender_id"/>
                  <ExcelColumn label="country" value="country"/>
                  <ExcelColumn label="state" value="state"/>
                  <ExcelColumn label="city" value="city"/>
                  <ExcelColumn label="CreatedAt" value="created_at"/>
                  <ExcelColumn label="Creation Source" value="creation_source"/>
                  <ExcelColumn label="Active" value="active"/>
                  <ExcelColumn label="Self Referral Code" value="referral_code"/>
                  <ExcelColumn label="Used Refrral Code" value="used_referral_code"/>
              </ExcelSheet>
            </ExcelFile>
          </div>
        )
      }

      userPreferenceComponent =(
        <div>
          <Select 
            name="preference"
            onChange={this.handleUserPreferenceChange}
            value={this.state.data.selectPreference}
            >
            <option value="" selected="">---User Preference---</option>
            {this.state.data.userPreferences.map(preference => (
              <option key={preference.name} value={preference.name} data-name={preference.name}>
                {preference.name} 
              </option>
            ))}
          </Select>
          <TextField autoComplete="off" className="admin-reg-filter-criteria" type="number" label="User Id" name="userId" onChange={this.onInputChange} value={this.state.data.userId}/>            
          <Button onClick={(e) => this.handlePreference(e, 'disable')}>Disable</Button>
          <Button onClick={(e) => this.handlePreference(e, 'enable')}>Enable</Button>
        </div>
      ) 

      return (
        <Grid>
          <GridCell span="12">
            <Card style={{ padding: '25px',textAlign: "center"}}>
              <Typography use="headline6"> User Details </Typography>
            </Card>
            <div className="opportunity-top-bar">
            <br/>
            Total Pages- {this.state.data.totalPages}
            <br/>
            </div>
          </GridCell>
          <GridCell span = "5">
            {paginationComponent}
          </GridCell>
          <GridCell span="7">
            <SearchComponent onHandleSearch = {handleUserSearch} onHandleClear = {handleClear} />
            <div style = {{paddingLeft: "90px"}}>
              <StatusMessage  error_msg = {this.state.searchErrorMsg}/>
            </div>
          </GridCell>
          
          <GridCell span = "6">
            {exportComponent}
          </GridCell>
          <GridCell span ="6">
            {userPreferenceComponent}
            <div style = {{paddingLeft: "30px"}}>
              <StatusMessage  error_msg = {this.state.prefErrorMsg}/>
            </div>
          </GridCell>
          <GridCell span = "12">
            <StatusMessage error_msg = {this.state.errorMsg}/>
            <div>
              <table className="admin-table">
                <th>User Id</th>
                <th>Name</th>
                <th>Email</th>
                <th>Phone</th>
                <th>Confirm OTP</th>
                <th>User Status</th>
                <th>Forgot Code</th>
                <th>Creation Source</th>
                <th>Email Preference</th>
                <th>first_name</th>
                <th>last_name</th>
                <th>gender_id</th>
                <th>dob</th>
                <th>Created At</th>
                <th>street</th>
                <th>locality</th>
                <th>city</th>
                <th>country_id</th>
                <th>state_id</th>
                {userListCompnent}
              </table>
            </div>

            
          </GridCell>
        </Grid>
      )
    
  }
}

function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(UserDetailsAdmin);


// WEBPACK FOOTER //
// ./src/views/admin/UserDetailsAdmin.jsx